var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50066 8.94C5.52066 9.09 5.47066 9.25 5.35566 9.355C5.16066 9.55 4.84566 9.55 4.65066 9.355L2.64566 7.35C2.53066 7.235 2.48066 7.08 2.50066 6.935V4.375L0.105661 1.31C-0.0643387 1.095 -0.0243387 0.78 0.190661 0.61C0.285661 0.54 0.390661 0.5 0.500661 0.5H7.50066C7.61066 0.5 7.71566 0.54 7.81066 0.61C8.02566 0.78 8.06566 1.095 7.89566 1.31L5.50066 4.375V8.94ZM1.52066 1.5L3.50066 4.03V6.79L4.50066 7.79V4.025L6.48066 1.5H1.52066Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.0280207e.svg";
export { ForwardRef as ReactComponent };